// extracted by mini-css-extract-plugin
module.exports = {"centered":"Centered_centered__gdSqM"};